import MonitorIcon from "@mui/icons-material/MonitorRounded";
import { Box, Grid, Typography, useTheme } from "@mui/material";
import type { ImpersonationContact, ImpersonationContactGroup } from "../../api/types/impersonationTypes";

interface Props {
  contact: ImpersonationContact;
  contactGroup: ImpersonationContactGroup;
  filterText: string;
  contactEmail: string;
  onContactViewClick: (email: string) => void;
}

const ImpersonationContactLine = ({ contact, contactGroup, filterText, contactEmail, onContactViewClick }: Props) => {
  const theme = useTheme();
  const filterTextVal = filterText.trim().toLowerCase();

  const colorSettings = {
    color: `${contact.email === contactEmail ? "#00A866" : theme.palette.text.secondary}`,
  };

  if (
    filterTextVal !== "" &&
    !contactGroup.title.toLowerCase().includes(filterTextVal) &&
    !contact.name.toLowerCase().includes(filterTextVal) &&
    !contact.email.toLowerCase().includes(filterTextVal) &&
    !contactGroup.fundName?.toLowerCase().includes(filterTextVal)
  ) {
    return null;
  }

  const isCurrentUser = contact.email === contactEmail;

  return (
    <Box
      sx={(theme) => ({
        height: "2.2rem",
        display: "flex",
        alignItems: "center",
        ...colorSettings,
        "&:hover": {
          backgroundColor: theme.palette.action.hover,
          cursor: isCurrentUser ? "arrow" : "pointer",
        },
        "& > *": {
          ...colorSettings,
        },
        paddingLeft: theme.spacing(2),
        marginLeft: theme.spacing(3),
      })}
      onClick={() => {
        if (!isCurrentUser) {
          onContactViewClick(contact.email);
        }
      }}
    >
      <Grid container sx={{ width: "100%", "& > .MuiGrid-item": { margin: "auto" } }}>
        <Grid size={5}>
          <Typography variant="subtitle2" sx={{ lineHeight: "1.5rem" }}>
            {contact.name}
          </Typography>
        </Grid>
        <Grid size={6}>
          <Typography
            variant="subtitle2"
            sx={(theme) => ({
              color: colorSettings.color || theme.palette.text.secondary,
              lineHeight: "1.5rem",
            })}
          >
            {contact.email}
          </Typography>
        </Grid>
        <Grid size={1}>{isCurrentUser && <MonitorIcon sx={{ ...colorSettings }} />}</Grid>
      </Grid>
    </Box>
  );
};

export default ImpersonationContactLine;
